
// Swiper

export const init = () => {
    jQuery(function(){
        const swiper = new Swiper(".js-swiper-service", {
            speed: 1000, // スライド変化時間
            loop: true,
            slidesPerView: 1.2,
            spaceBetween: 20,
            autoplay: {
                delay: 4000, //　スライダー表示時間
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true,
            },
            // 前後の矢印
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                // スライドの表示枚数：500px以上の場合
                769: {
                    slidesPerView: 3,
                }
            }
        });
    
        const swiperMv = new Swiper(".js-swiper-mv", {
            speed: 1000, // スライド変化時間
            loop: true,
            slidesPerView: 1,
            centerSlides: true,
            autoplay: {
                delay: 4000, //　スライダー表示時間
                disableOnInteraction: false,
            },
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true,
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    
        const swiperGallery = new Swiper(".js-swiper-gallery", {
            speed: 4000, // スライド変化時間
            loop: true,
            slidesPerView: 2,
            spaceBetween: 0,
            centerSlides :true,
            autoplay: {
                delay: 0, //　スライダー表示時間
                disableOnInteraction: false,
            },
            breakpoints: {
                // スライドの表示枚数：500px以上の場合
                769: {
                    slidesPerView: 4,
                }
            },
        });
    })
};
export default init;
